import React, { useState, useRef } from 'react';
import DownloadTable from './DownloadTable';


export default function ListaDadosBasicosSaneamento(props) {
    const tableRef = useRef();
    const [table, setTable] = useState(props.table);
    const fileNameTemplate = table.linhas[0][0][1][0];

    return (
        <>
            <DownloadTable tableRef={tableRef} template={fileNameTemplate} />
            <table ref={tableRef} className="table  table-sm small table-hover" id='table_dados_basicos_saneamento'>
                <thead>
                    <tr key={Math.random()}>
                        {table.cabecalho.map((cabecalho, i) => <th className={i > 0 && 'text-right'} style={{ textTransform: 'uppercase' }}>  {cabecalho} </th>)}
                    </tr>
                </thead>
                <tbody>
                    {table.linhas.map(linhas =>
                        <tr key={Math.random()}>
                            {linhas.map(linha =>
                                <>
                                    <td>{linha[0]}</td>
                                    {linha[1].map(item => <td className='text-right'> {item.valor} </td>)}
                                </>)}
                        </tr>
                    )}
                </tbody>
            </table>
        </>
    )
}

